import { useQuery, queryOptions } from '@tanstack/vue-query';
import { computed, unref, type MaybeRef } from 'vue';
import httpClient from '../httpClient';
import type { MantaPatient, PaginatedResponse } from '@/types';

export const useClientPatients = (
  clientId: MaybeRef<string | undefined>,
  enabled?: MaybeRef<boolean>,
) => {
  const id = computed(() => unref(clientId));
  const isEnabled = computed(
    () => !!id.value && (unref(enabled) ?? true),
  );

  return useQuery(
    queryOptions({
      queryKey: computed(() => ['scribeClientPatients', id.value]),
      queryFn: async (): Promise<MantaPatient[]> => {
        const response = await httpClient.get<
          PaginatedResponse<MantaPatient> | MantaPatient[]
        >(`/v1/clients/${id.value}/patients`);
        return Array.isArray(response.data)
          ? response.data
          : (response.data.data ?? []);
      },
      enabled: isEnabled,
      staleTime: 10_000,
    }),
  );
};
